import * as React from "react";
const SvgFiRrCars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cars_svg__a)">
      <path
        fill="#062147"
        d="M24 18.079c0-1.49-.255-2.97-.757-4.373l-.853-2.388A5.01 5.01 0 0 0 17.681 8H13.32a5.01 5.01 0 0 0-4.709 3.318l-.853 2.388C6.9 16.223 6.21 20 9 21.5v.5a2 2 0 0 0 4 0h5a2 2 0 0 0 4 0v-.5a3.92 3.92 0 0 0 2-3.421M13.32 10h4.361a3.005 3.005 0 0 1 2.825 1.991L21.224 14H9.776l.718-2.009A3.005 3.005 0 0 1 13.32 10m6.76 10H10.92c-2.172-.051-2.08-2.431-1.72-4H11v1a1 1 0 1 0 2 0v-1h5v1a1 1 0 1 0 2 0v-1h1.8c.36 1.569.45 3.95-1.722 4M4 9V8H2.2c-.358 1.569-.448 3.95 1.723 4H5a1 1 0 0 1 1 1v1a2 2 0 0 1-4 0v-.5C-.792 11.994-.1 8.225.757 5.706l.853-2.388A5.01 5.01 0 0 1 6.32 0h4.361a5.01 5.01 0 0 1 4.71 3.318l.48 1.346a1 1 0 0 1-1.884.672l-.48-1.345A3.01 3.01 0 0 0 10.68 2H6.32a3.005 3.005 0 0 0-2.825 1.991L2.776 6H8a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCars;
